import React from 'react';
import PropTypes from 'prop-types';
import { Block } from '../partials';

const propTypes = {
    title: PropTypes.string,
    blocks: PropTypes.array,
};

const defaultProps = {
    title: null,
    blocks: [],
};

const StatsLayout = ({ title, blocks }) => {
    const mediaTypes = ['media', 'image', 'video'];
    const pageBlocks = (blocks || []);
    const mediasBlocks = pageBlocks.filter(block => mediaTypes.indexOf(block.type) !== -1);
    const leftBlocks = pageBlocks.filter(block => mediaTypes.indexOf(block.type) === -1);
    const firstMedia = mediasBlocks.length > 0 ? mediasBlocks[0] : null;
    const otherMedias = mediasBlocks.length > 0 ? mediasBlocks.slice(1) : [];
    if (firstMedia !== null) {
        leftBlocks.push({
            ...firstMedia,
            box: false,
            showPicture: true,
        });
        otherMedias.push({
            ...firstMedia,
        });
    }

    return (
        <div className="layout layout-with-cols layout-stats">
            <h1 className="title page-title">{title}</h1>
            <div className="cols">
                <div className="col">
                    <Block blocks={leftBlocks} />
                </div>
                <div className="col col-very-small">
                    <div className="col-inner">
                        <Block blocks={otherMedias} />
                    </div>
                </div>
            </div>
        </div>
    );
};

StatsLayout.propTypes = propTypes;
StatsLayout.defaultProps = defaultProps;

export default StatsLayout;



// WEBPACK FOOTER //
// ./components/layouts/StatsLayout.jsx